<template>
  <st-side-page class="cashier-page">
    <template slot="side">
      <ul class="menu">
        <li class="menu-item" v-for="(menu, i) in menus" :key="i">
          <router-link :to="menu.path">{{ menu.label }}</router-link>
          <fa-icon :icon="['fal', 'chevron-right']"/>
        </li>
      </ul>
      <!-- TODO(rollout-caixa-novo): reativar assim que esta versão subir
           (card de ativação do novo caixa)
      <div class="cashier-new-cta" v-if="canManageSettings">
        <span class="cashier-new-cta-badge">Novidade</span>
        <span class="cashier-new-cta-icon"><fa-icon :icon="['fal', 'cash-register']"/></span>
        <div class="cashier-new-cta-title">Novo caixa</div>
        <div class="cashier-new-cta-text">
          Cada operador com a própria sessão e recebimento direto da agenda.
        </div>
        <router-link to="/cash-register/settings" class="btn btn-primary btn-sm btn-block">
          Conhecer e ativar
        </router-link>
      </div>
      -->
    </template>
    <router-view/>
  </st-side-page>
</template>

<script>
import { MANAGE_CASHIER_SETTINGS } from '@/data/actions/modules/financial';

export default {
  computed: {
    canManageSettings() {
      return this.$can(MANAGE_CASHIER_SETTINGS);
    },
  },
  data() {
    return {
      menus: [
        { path: '/cashier-opening', label: 'Abertura' },
        { path: '/cashier-operations', label: 'Aporte/Sangria' },
        { path: '/cashier-financial', label: 'Receita/Despesa' },
        { path: '/cashier-attendances', label: 'Atendimentos' },
        { path: '/cashier-referrals', label: 'Encaminhamentos' },
        { path: '/cashier-cash-flow', label: 'Fluxo de caixa' },
        { path: '/cashier-closure', label: 'Fechamento' },
        { path: '/cashier-configuration', label: 'Configuração' },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
  .cashier-page {
    &.side-page {
      .side-page-side {
        flex: 0 0 11rem;
      }
    }
    .menu {
      .router-link-exact-active {
        color: $primary-color;
        & + svg {
          color: $primary-color;
        }
      }
    }
    .cashier-new-cta {
      background: linear-gradient(
        160deg,
        lighten($primary-color, 43%),
        lighten($primary-color, 38%)
      );
      border: lighten($primary-color, 30%) solid $border-width;
      border-radius: $border-radius;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: .3rem;
      margin: $layout-spacing-lg $layout-spacing-sm 0;
      padding: $layout-spacing $layout-spacing-sm $layout-spacing-sm;
      position: relative;
      text-align: center;
      .cashier-new-cta-badge {
        background-color: $primary-color;
        border-radius: 1rem;
        color: $light-color;
        font-size: .5rem;
        font-weight: 700;
        letter-spacing: .06em;
        line-height: 1;
        padding: .2rem .45rem;
        position: absolute;
        right: .5rem;
        text-transform: uppercase;
        top: -.45rem;
      }
      .cashier-new-cta-icon {
        align-items: center;
        background-color: $light-color;
        border-radius: 50%;
        box-shadow: 0 2px 6px rgba($primary-color, .2);
        color: $primary-color;
        display: flex;
        font-size: 1.4rem;
        height: 3rem;
        justify-content: center;
        margin-bottom: .3rem;
        width: 3rem;
      }
      .cashier-new-cta-title {
        color: $dark-color;
        font-size: $font-size-lg;
        font-weight: 700;
        line-height: 1.2;
      }
      .cashier-new-cta-text {
        color: $gray-color-dark;
        font-size: $font-size-xs;
        line-height: 1.35;
        margin-bottom: .5rem;
      }
    }
  }
</style>
